function News() {
    try {
        const news = [
            {
                title: "SCN Expands to Support Rural Schools in Europe",
                date: "2024-03-15",
                excerpt: "Our latest initiative brings refurbished computing labs to underserved communities across Eastern Europe."
            },
            {
                title: "Partnership with SCN Recycling Ltd Announced",
                date: "2024-02-10",
                excerpt: "New collaboration will dramatically increase our capacity to refurbish and repurpose e-waste for education."
            },
            {
                title: "Sustainable Computing Workshop Series Launches",
                date: "2024-01-05",
                excerpt: "Free training programs help educators maximize the potential of our donated technology in classrooms."
            }
        ];

        return (
            <section data-name="news" id="news" className="section bg-gray-50/50 backdrop-blur-sm">
                <div className="container">
                    <h2 data-name="news-title" className="text-5xl font-bold text-center mb-16 text-gray-800">
                        Latest <span className="text-green-600">Updates</span>
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {news.map((item, index) => (
                            <article 
                                data-name="news-card" 
                                key={index} 
                                className="bg-white/90 backdrop-blur-md rounded-xl shadow-lg overflow-hidden transition-all duration-500 hover:shadow-xl hover:-translate-y-2"
                            >
                                <div className="p-6">
                                    <time className="text-sm text-gray-500">{item.date}</time>
                                    <h3 className="text-xl font-semibold mt-2 mb-3">{item.title}</h3>
                                    <p className="text-gray-600 mb-4">{item.excerpt}</p>
                                    <a href="#" className="inline-flex items-center text-green-600 hover:text-green-700 transition-colors duration-300">
                                        Read More
                                        <i className="fas fa-arrow-right ml-2 transition-transform duration-300 group-hover:translate-x-1"></i>
                                    </a>
                                </div>
                            </article>
                        ))}
                    </div>
                    <div className="mt-12 text-center">
                        <a href="#" className="btn btn-secondary inline-flex items-center">
                            View All News
                            <i className="fas fa-newspaper ml-2"></i>
                        </a>
                    </div>
                </div>
            </section>
        );
    } catch (error) {
        console.error('News error:', error);
        reportError(error);
        return null;
    }
}

export default News;
